var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{ref:"card",staticClass:"p-1"},[_c('form-component',{attrs:{"page":_vm.shareholdersCommunication},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchShareholdersCommunication}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }